module.exports = __webpack_public_path__ + "ed3c22feb6fd107ef6b2057679be9496.svg";